import React from 'react';
import * as Styled from './styled';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';
import { RecentReportCellClickHandler } from '.';
import { ReportResult, InProgressStatus } from '../../../models';
import { Icon } from '../../../components';

interface ArchiveButtonCellProps {
  cell: TableCell;
}

const createArchiveButtonCell = (onClick: RecentReportCellClickHandler) => ({
  cell,
}: ArchiveButtonCellProps): JSX.Element => {
  const rowData = cell.row.original as ReportResult;
  const clickHandler = (): void => onClick(rowData);
  const disabled = rowData.statusId !== InProgressStatus.taskComplete;
  return !rowData.isArchived ? (
    <Styled.ActionButton onClick={clickHandler} disabled={disabled}>
      <Icon name="archive" disabled={disabled} />
    </Styled.ActionButton>
  ) : (
    <Icon name="check" />
  );
};

export default createArchiveButtonCell;
